import pixAxios from '@/axios/pixAxios.js';
// import store from '@/store/index.js';
// import asyncUtils from '@/services/common/async.utils.js';

const urlJobApi = 'https://apigea.qrmjll.com/pixv2apisbx/api/JobProperty/';
const suscriptionKeyValue = '30e72d4f8c444a99bd3e0cc434d7caf6';
const headers = {
  'Ocp-Apim-Subscription-Key': suscriptionKeyValue,
  'Subscription-Key': suscriptionKeyValue,
};

export default {
  //Review data. Failed to test due to 401 error from endpoint getPropertiesByJobId
  addProperty: (body) => {
    return pixAxios.put(`${urlJobApi}AddPropertyToJob`, body, { headers }).then(({ data }) => data);
  },

  //Review data. Failed to test due to 401 error from endpoint getPropertiesByJobId
  getPropertyById: (rowId, withAttributes = true) => {
    const body = {
      rowId,
      withAttributes,
    };
    return pixAxios.get(`${urlJobApi}GetJobProperty`, body, { headers }).then(({ data }) => data);
  },
};
